(function($) {

    var heroMp4File = $('#hero-mp4-file'),
        heroWebmFile = $('#hero-webm-file'),
        heroVideoContainer = $('#hero-video-container'),
        heroOverlay = $('.hero-overlay');

    if (heroVideoContainer.length && $(window).width() > 768) {

        var heroVideoObject = document.createElement("video");

        $('.bg-img').addClass('d-none');

        $(heroVideoObject).addClass('hero-video');

        if (heroMp4File.length) {
            var sourceMP4 = document.createElement("source");
            sourceMP4.type = "video/mp4;";
            sourceMP4.src = heroMp4File.val();
            heroVideoObject.appendChild(sourceMP4);
        }

        if (heroWebmFile.length) {
            var sourceWebM = document.createElement("source");
            sourceWebM.type = "video/webm";
            sourceWebM.src = heroWebmFile.val();
            heroVideoObject.appendChild(sourceWebM);
        }

        heroVideoObject.autoplay = true;
        heroVideoObject.muted = true;
        heroVideoObject.loop = true;
        heroVideoObject.playsinline = true;
        heroVideoObject.load();

        var playPromise = heroVideoObject.play();

        if (playPromise !== undefined) {
            playPromise.then(function () {
                // console.log('Automatic playback started!');
            }).catch(function (error) {
                // console.log(error);
                // Automatic playback failed.
                // Show a UI element to let the user manually start playback.
            });
        }

        heroVideoContainer.append(heroVideoObject);

        heroOverlay.addClass('hiding');
        setTimeout(function () {
            heroOverlay.addClass('d-none');
            $('.bg-img').removeClass('d-none');
        }, 1010);
    }

}(jQuery));